import React from "react";
import TextInput from "../../input/TextField/TextInput";
import CheckBox from "../../input/checkBox/CheckBox";
import { TrashIcon } from "@heroicons/react/24/solid";
import { useEffect } from "react";
import { useState } from "react";

function AddExp({
  index,
  values,
  expCount = 0,
  setExpCount = ()=>{},
  expArray,
  setExpArray
}) {
   
  const [companyExp, setCompanyExp] = useState({
    experienceFrom: "",
    jobProfile: "",
    startDate: "",
    endDate: "",
    currentlyWorking: false,
  }); 
  

   useEffect(()=>{
    if(values){
     setCompanyExp({
      ...companyExp,
      experienceFrom: values?.company_name,
      jobProfile: values?.job_designation,
      startDate: values?.start_date,
      endDate: values?.end_date,
      currentlyWorking: values?.is_currently_working,
     })
    }
   },[index,expArray.length]);

   const handleChangeWorkExp = (e) => {
    setCompanyExp({ ...companyExp, experienceFrom: e.target.value });
    const updated = [...expArray];
     updated[index] = {...updated[index], company_name: e.target.value};
     setExpArray(updated); 
  };

  const handleChangeJobProfile = (e) => {
    setCompanyExp({ ...companyExp, jobProfile: e.target.value });
    const updated = [...expArray];
    updated[index] = {...updated[index], job_designation: e.target.value};
    setExpArray(updated); 
  };

  const handleChangeStartDate=(e) =>{
    setCompanyExp({ ...companyExp, startDate: e.target.value })
    const updated = [...expArray];
    updated[index] = {...updated[index], start_date: e.target.value};
    setExpArray(updated); 
  }

  const handleChangeEndDate=(e) =>{
  
    setCompanyExp({ ...companyExp, endDate: e.target.value })
    const updated = [...expArray];
    updated[index] = {...updated[index], end_date: e.target.value};
    setExpArray(updated); 
  }
  const handleChangeChecked=(e) =>{
    setCompanyExp({
      ...companyExp,
      currentlyWorking: e.target.checked,
    });   
     const updated = [...expArray];
    updated[index] = {...updated[index], is_currently_working: e.target.checked};
    delete updated[index]?.end_date
    setExpArray(updated); 
  }

  const handleDelete = () =>{
    setExpCount(expCount - 1);
    const updatedItems = [...expArray];
    updatedItems.splice(index, 1);
    setExpArray(updatedItems);
  }


  return (
    <>
      <div>
        <TextInput
          value={companyExp.experienceFrom}
          onChange={handleChangeWorkExp}
          label="Company Name"
          placeholder="Company name"
        />
      </div>
      <div>
        <TextInput
          label="Job Title"
          placeholder="Job title"
          onChange={handleChangeJobProfile}
          value={companyExp.jobProfile}
        />
      </div>
      <div>
        <label style={{ fontFamily: "gilRoy-semibold" }} className="text-sm  ">
          Start Date
        </label>
        <div className="relative w-full mt-[10px] ">
          <input
            // datepicker
            // datepicker-autohide
            value={companyExp.startDate}
            type="date"
            className=" border bg-white  h-[45px] border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
            placeholder="Select date"
            onChange={handleChangeStartDate}
            // onClick={(e) => dobHandler(e)}
            // onClick={(e) => console.log(e.target.value)}
            // onChange={(e) => console.log(e)}
            id="date"
          />
          {/* <div className="flex absolute inset-y-0 right-0 items-center pr-3 pointer-events-none">
              <CalendarDaysIcon className="w-5 h-5 text-gray-500 cursor-pointer " />
            </div> */}
        </div>
      </div>
      <div>
        <label style={{ fontFamily: "gilRoy-semibold" }} className="text-sm  ">
          End Date
        </label>
        <div className="relative w-full mt-[10px] ">
          <input
            // datepicker
            disabled={companyExp.currentlyWorking}
            value={companyExp.endDate}
            // datepicker-autohide
            placeholder="End date"
            type="date"
            className=" border bg-white  h-[45px] border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  "
            onChange={handleChangeEndDate}
            id="date"
          />
          {/* <div className="flex absolute inset-y-0 right-0 items-center pr-3 pointer-events-none cursor-pointer">
              <CalendarDaysIcon className="w-5 h-5 text-gray-500 cursor-pointer " />
            </div> */}
        </div>
        <div style={{ marginTop: "-10px" }}>
          <CheckBox
            label="Currently working"
            value={companyExp?.currentlyWorking}
            onChange={handleChangeChecked}
          />
        </div>
      </div>
      {/* //Deleted */}
      <div className="mt-[-35px]">
        <button
          className=" text-xs text-red-600 flex items-center "
          disabled={expArray.length === 1}
          onClick={handleDelete}
        >
          <TrashIcon className="text-red-600 h-4 w-4 mr-1" /> Delete experience
        </button>
      </div>
      <div></div>
    </>
  );
}

export default AddExp;
